import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M15.307 2.212a6.3 6.3 0 0 1-1.981.76A3.128 3.128 0 0 0 8.009 5.82a8.85 8.85 0 0 1-6.433-3.263 3.13 3.13 0 0 0 .97 4.17 3.1 3.1 0 0 1-1.408-.407 3.13 3.13 0 0 0 2.523 3.097c-.459.124-.94.142-1.407.052a3.13 3.13 0 0 0 2.888 2.169 6.26 6.26 0 0 1-3.868 1.334 6 6 0 0 1-.74 0 8.8 8.8 0 0 0 4.774 1.397 8.81 8.81 0 0 0 8.873-8.872v-.407a6.3 6.3 0 0 0 1.543-1.647 6.3 6.3 0 0 1-1.793.49 3.13 3.13 0 0 0 1.376-1.72"
    }, null, -1)
  ])))
}
export default { render: render }